import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../../../styles/dashboardTheme.css";
import "../../../../styles/managementTheme.css";
import "../styles/matriculas.css";
import MatriculasSummary from "../components/MatriculasSummary";
import MatriculasFilters from "../components/MatriculasFilters";
import MatriculasTable from "../components/MatriculasTable";
import MatriculaFormModal from "../components/MatriculaFormModal";
import TransferirMatriculaModal from "../components/TransferirMatriculaModal";
import { usePermissions } from "../../../../utils/permissions";

export default function MatriculasView({
  loading,
  error,
  resumen,
  filtros,
  setFiltros,
  limpiarFiltros,
  lastUpdated,
  page,
  pageSize,
  totalPages,
  total,
  goToPage,
  matriculasPaginadas,
  seleccionado,
  seleccionar,
  reload,
  form,
  contrato,
  ciclosOptions,
  promocionesOptions,
  cursosOptions,
  loadingOptions,
  reloadOptions,
  ciclosOptionsMatriculaNueva,
  promocionesOptionsMatriculaNueva,
  incluirFinalizadas,
  toggleIncluirFinalizadas,
  loadingFinalizadas,
}) {
  const { hasPermission } = usePermissions();
  const canCreate = hasPermission("matriculas.crear");
  const canUpdate = hasPermission("matriculas.actualizar");
  const canDelete = hasPermission("matriculas.eliminar");
  const canTransfer = hasPermission("matriculas.transferir");
  const canGenerateContrato = hasPermission("contratos.generar");
  const canDownloadContrato = hasPermission("contratos.ver");

  const [transferirMatricula, setTransferirMatricula] = useState(null);

  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    if (form.modal) document.body.classList.add("modal-open");
    else document.body.classList.remove("modal-open");
    return () => document.body.classList.remove("modal-open");
  }, [form.modal]);

  const quickFilter = (key) => {
    switch (key) {
      case "activas":
        setFiltros((prev) => ({ ...prev, estado_matricula: "activa", estado_pago: "all" }));
        break;
      case "pendientesPago":
        setFiltros((prev) => ({ ...prev, estado_pago: "pendiente" }));
        break;
      case "pagoParcial":
        setFiltros((prev) => ({ ...prev, estado_pago: "parcial" }));
        break;
      case "pagadas":
        setFiltros((prev) => ({ ...prev, estado_pago: "pagado" }));
        break;
      case "finalizadas":
        setFiltros((prev) => ({ ...prev, estado_matricula: "finalizada" }));
        break;
      default:
        setFiltros((prev) => ({ ...prev, estado_matricula: "all", estado_pago: "all" }));
        break;
    }
  };

  const activeQuickFilter =
    filtros?.estado_matricula === "activa"
      ? "activas"
      : filtros?.estado_matricula === "finalizada"
        ? "finalizadas"
        : filtros?.estado_pago === "pendiente"
          ? "pendientesPago"
          : filtros?.estado_pago === "parcial"
            ? "pagoParcial"
            : filtros?.estado_pago === "pagado"
              ? "pagadas"
              : "total";

  const lastSync = lastUpdated ? lastUpdated.toLocaleString() : "Sincronización inicial";

  return (
    <section className="management-page management-theme-violet">
      <div className="management-card management-header mb-4">
        <div>
          <p className="management-eyebrow mb-1">Académico / Matrículas</p>
          <h4 className="management-title mb-1">Gestión de matrículas</h4>
          <p className="text-muted mb-0">Consulta y administra las matrículas de estudiantes.</p>
        </div>
        <div className="d-flex flex-column align-items-end gap-2">
          {canCreate && (
            <button type="button" className="btn management-btn-primary" onClick={form.abrirCrear}>
              <i className="bi bi-plus-circle me-2" />
              Nueva matrícula
            </button>
          )}
          <small className="text-muted">Actualizado: {lastSync}</small>
        </div>
      </div>

      <MatriculasSummary resumen={resumen} onQuickFilter={quickFilter} activeKey={activeQuickFilter} />

      <MatriculasFilters filtros={filtros} setFiltros={setFiltros} limpiarFiltros={limpiarFiltros} />

      <MatriculasTable
        matriculas={matriculasPaginadas}
        loading={loading}
        error={error}
        seleccionadoId={seleccionado?.id}
        onSelect={seleccionar}
        onEdit={canUpdate ? form.abrirEditar : undefined}
        onDelete={canDelete ? form.abrirEliminar : undefined}
        onTransferir={canTransfer ? setTransferirMatricula : undefined}
        onViewDetail={() => {}}
        canEdit={canUpdate}
        canDelete={canDelete}
        canTransfer={canTransfer}
        onGenerateContract={canGenerateContrato ? contrato?.generar : undefined}
        onDownloadContract={canDownloadContrato ? contrato?.descargar : undefined}
        contractLoadingId={contrato?.loadingId}
        contractLoadingType={contrato?.loadingType}
        canGenerateContract={canGenerateContrato}
        canDownloadContract={canDownloadContrato}
        reload={reload}
      />

      <div className="management-card d-flex justify-content-between align-items-center flex-wrap gap-3">
        <div className="text-muted small">
          Mostrando {total === 0 ? 0 : (page - 1) * pageSize + 1}-{Math.min(total, page * pageSize)} de {total}
        </div>
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <div className="btn-group">
            <button className="btn btn-outline-secondary btn-sm" onClick={() => goToPage(page - 1)} disabled={page <= 1}>
              <i className="bi bi-chevron-left" />
            </button>
            <button className="btn btn-outline-secondary btn-sm" disabled>
              Página {page} / {totalPages}
            </button>
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={() => goToPage(page + 1)}
              disabled={page >= totalPages}
            >
              <i className="bi bi-chevron-right" />
            </button>
          </div>
        </div>
      </div>

      <MatriculaFormModal
        {...form}
        ciclosOptions={ciclosOptions}
        promocionesOptions={promocionesOptions}
        cursosOptions={cursosOptions}
        loadingOptions={loadingOptions}
        reloadOptions={reloadOptions}
        ciclosOptionsMatriculaNueva={ciclosOptionsMatriculaNueva}
        promocionesOptionsMatriculaNueva={promocionesOptionsMatriculaNueva}
        incluirFinalizadas={incluirFinalizadas}
        toggleIncluirFinalizadas={toggleIncluirFinalizadas}
        loadingFinalizadas={loadingFinalizadas}
      />

      {transferirMatricula && (
        <TransferirMatriculaModal
          matricula={transferirMatricula}
          promocionesOptions={promocionesOptions}
          onClose={() => setTransferirMatricula(null)}
          onTransferida={(actualizada) => {
            reload();
            setTransferirMatricula(null);
          }}
        />
      )}
    </section>
  );
}
